import { render, staticRenderFns } from "./EvaluationStatisticsStudent.vue?vue&type=template&id=64ab975c&scoped=true"
import script from "./EvaluationStatisticsStudent.vue?vue&type=script&lang=js"
export * from "./EvaluationStatisticsStudent.vue?vue&type=script&lang=js"
import style0 from "./EvaluationStatisticsStudent.vue?vue&type=style&index=0&id=64ab975c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab975c",
  null
  
)

export default component.exports